import { useContext } from "react";

import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";

import some from "lodash/some";

const MapPopup = ({ hoveredFtr }) => {
    const { screenSize } = useViewport();
    const { state } = useContext(appContext);

    if (!hoveredFtr) return null;
    const addOrRemove = some(state.selectedGeos, { id: hoveredFtr.id }) ? "remove" : "add";
    const clickOrTap = screenSize === "mobile" ? "Tap" : "Click";
    return (
        <div style={{ background: "#333", fontFamily: "museo-sans, sans-serif", fontSize: "16px" }}>
            <div style={{ fontSize: "1em", fontWeight: 700, padding: "0.125em 1em 0", textAlign: "center" }}>
                {hoveredFtr.properties.name}
            </div>
            <div
                style={{
                    fontSize: "0.9em",
                    textTransform: "uppercase",
                    letterSpacing: "2px",
                    padding: "0 1em 0.125em",
                    textAlign: "center",
                }}
            >
                {clickOrTap} to <b>{addOrRemove}</b>
            </div>
        </div>
    );
};
export default MapPopup;
